import { render, staticRenderFns } from "./unit-quantities.vue?vue&type=template&id=3508fb80&scoped=true&"
import script from "./unit-quantities.vue?vue&type=script&lang=js&"
export * from "./unit-quantities.vue?vue&type=script&lang=js&"
import style0 from "./unit-quantities.vue?vue&type=style&index=0&id=3508fb80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508fb80",
  null
  
)

export default component.exports